module.exports = "/images/AP.png?b7333f2e70566ed33588b7980abb8a42";